<script setup lang="ts">
const emit = defineEmits<{ (e: 'onInfinite', value: InfiniteLoadingEvent): void }>();

function handleFetchData($event: InfiniteLoadingEvent) {
  emit('onInfinite', $event);
}
</script>

<template>
  <InfiniteLoading class="infinite-loading" @infinite="handleFetchData">
    <template #complete>
      <slot name="complete" />
    </template>
    <template #spinner>
      <slot name="spinner" />
    </template>
  </InfiniteLoading>
</template>

<style lang="scss" scoped>
.infinite-loading {
  height: 100%;
}
</style>
